<template>
    <v-row class="ma-0 pa-0" align="center" justify="center">
      <v-col cols="12" class="chart_style">
        <v-chart :id="chart_id" :ref="chart_ref" class="chart" :option="option" autoresize></v-chart>
      </v-col>
    </v-row>
  </template>
  
  <script>
  import VChart, { THEME_KEY } from "vue-echarts";
  import "echarts";
  import { use } from "echarts/core";
  import { CanvasRenderer } from "echarts/renderers";
  import { TitleComponent, TooltipComponent, LegendComponent } from "echarts/components";
  import * as echarts from 'echarts';
  
  use([CanvasRenderer, TitleComponent, TooltipComponent, LegendComponent]);
  export default {
    name: "ReachChart",
    props: ["chart_title", "chart_data", "chart_id", "chart_ref", "chart_options"],
    components: {
      VChart,
    },
    provide: {
      [THEME_KEY]: "light",
    },
    setup(props) {
      let channels = [];
      console.log('CD', props.chart_data)
      for(let row of props.chart_data){
        if(row[0] !== 'Face ID' && !channels.includes(row[0])){
          channels.push(row[0])
        }
      }
      const datasetWithFilters = [];
      const seriesList = [];
      echarts.util.each(channels, function (channel) {
          var datasetId = 'dataset_' + channel;
          datasetWithFilters.push({
            id: datasetId,
            fromDatasetId: 'dataset_raw',
            transform: {
                type: 'filter',
                config: {
                  and: [
                      { dimension: 'Face ID', '=': channel }
                  ]
                }
            }
          });
          seriesList.push({
            type: 'line',
            datasetId: datasetId,
            showSymbol: false,
            name: channel,
            endLabel: {
                show: false,
                formatter: function (params) {
                return params.value[3] + ': ' + params.value[0];
                }
            },
            labelLayout: {
                moveOverlap: 'shiftY'
            },
            emphasis: {
                focus: 'series'
            },
            encode: {
                x: 'Date',
                y: 'Reach Pacing',
                label: ['Face ID', 'Reach'],
                itemName: 'Date',
                tooltip: ['Reach Pacing']
            }
          });
      });
      console.log(seriesList)
      console.log(datasetWithFilters)
      let option = {
          animationDuration: 1000,
          dataset: [
              {
                  id: 'dataset_raw',
                  source: props.chart_data, 
              },
              ...datasetWithFilters
          ],
          color: [
            "#70E000", "#A4133C", "#2AB7CA", "#3A0CA3", "#F6BD60", "#1F4E5F", "#F28482",
            "#2F5D50", "#9FE0D0", "#A44A3F", "#CDB4DB", "#D7263D", "#75B9E3", "#6B8E23",
            "#E8B4B8", "#1E3A8A", "#F77F00", "#6D597A", "#A7C957", "#D0006F", "#B7D3E9",
            "#4A6F46", "#F4A261", "#2E5AAC", "#9CAF88", "#7B2CBF", "#C19A6B", "#00B4D8",
            "#C08497", "#2A9D8F", "#E9C46A", "#3A86C8", "#B46A55", "#4EC5C1", "#D4A017",
            "#A2678A", "#D8C3A5", "#C06542", "#B8A1D9", "#D6E6F2"
          ],
          title: {
            text: props.chart_title,
            fontFamily: "Poppins",
            left: 'center',
          },
          legend: {
            data: channels,
            type: "scroll",
            left: 'center',
            top: '5%',
            width: "90%",
            textStyle: {
                fontFamily: "Poppins",
                fontSize: 12
            }
          },
          tooltip: {
              order: 'valueAsc',
              trigger: 'axis',
              formatter: function (params) {
                const title = params[0].axisValueLabel || params[0].axisValue;

                const body = params.map(item => {
                    return `${item.marker}${item.seriesName || ''}: ${(item.value[2] * 100).toFixed(1)}%`;
                }).join('<br/>');

                return `<strong>${title}</strong><br/>${body}`;
              }
          },
          xAxis: {
              type: 'category',
              axisLabel: {
                  fontSize: 12,
                  fontFamily: "Poppins"
              },
              name: 'Date',
              nameLocation: 'middle',
              nameGap: 30,
              nameTextStyle: {
                  fontSize: 14,
                  fontFamily: "Poppins",
                  fontWeight: 'bold'
              }
          },
          yAxis: {
              axisLabel: {
                  formatter: function (value) {
                      return (value * 100).toFixed(0) + '%';
                  },
                  fontSize: 12,
                  fontFamily: "Poppins"
              },
              name: 'Unique Reach %',
              nameLocation: 'middle',
              nameGap: 40,
              nameTextStyle: {
                  fontSize: 14,
                  fontFamily: "Poppins",
                  fontWeight: 'bold'
              }
          },
          grid: {
              left: '4%',
              right: '0%',
              top: '10%',
              bottom: '7%'
          },
          series: seriesList
      }
      return {option}
    },
    methods: {},
  };
  </script>
  
  <style scoped>
  .chart_title {
    font-family: "Poppins" !important;
    font-size: 10pt !important;
    line-height: 40px;
  
    display: block;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .chart_style {
    height: 60vh;
    font-family: "Poppins" !important;
  }
  </style>
  